export const GET_INBOX_MAILS = "GET_INBOX_MAILS";
export const GET_INBOX_MAILS_SUCCESS = "GET_INBOX_MAILS_SUCCESS";
export const GET_INBOX_MAILS_FAIL = "GET_INBOX_MAILS_FAIL";

export const SEND_MAIL_TO_USER = "SEND_MAIL_TO_USER";
export const SEND_MAIL_TO_USER_SUCCESS = "SEND_MAIL_TO_USER_SUCCESS";
export const SEND_MAIL_TO_USER_FAIL = "SEND_MAIL_TO_USER_FAIL";

export const ADD_EMAIL_SIGN = "ADD_EMAIL_SIGN";
export const ADD_EMAIL_SIGN_SUCCESS = "ADD_EMAIL_SIGN_SUCCESS";
export const ADD_EMAIL_SIGN_FAIL = "ADD_EMAIL_SIGN_FAIL";

//starred mail
export const SET_MAIL_READ = "SET_MAIL_READ";
export const SET_MAIL_READ_SUCCESS = "SET_MAIL_READ_SUCCESS";
export const SET_MAIL_READ_FAIL = "SET_MAIL_READ_FAIL";

//important mail
export const GET_IMPORTANT_MAILS = "GET_IMPORTANT_MAILS";
export const GET_IMPORTANT_MAILS_SUCCESS = "GET_IMPORTANT_MAILS_SUCCESS";
export const GET_IMPORTANT_MAILS_FAIL = "GET_IMPORTANT_MAILS_FAIL";

//sent mail
export const GET_SENT_MAILS = "GET_SENT_MAILS";
export const GET_SENT_MAILS_SUCCESS = "GET_SENT_MAILS_SUCCESS";
export const GET_SENT_MAILS_FAIL = "GET_SENT_MAILS_FAIL";

//draft mail
export const GET_DRAFT_MAILS = "GET_DRAFT_MAILS";
export const GET_DRAFT_MAILS_SUCCESS = "GET_DRAFT_MAILS_SUCCESS";
export const GET_DRAFT_MAILS_FAIL = "GET_DRAFT_MAILS_FAIL";

export const GET_PARTICIPANT_EMAILS = "GET_PARTICIPANT_EMAILS";
export const GET_PARTICIPANT_EMAILS_SUCCESS = "GET_PARTICIPANT_EMAILS_SUCCESS";
export const GET_PARTICIPANT_EMAILS_FAIL = "GET_PARTICIPANT_EMAILS_FAIL";

export const REPLY_TO_EMAIL = "REPLY_TO_EMAIL";
export const REPLY_TO_EMAIL_SUCCESS = "REPLY_TO_EMAIL_SUCCESS";
export const REPLY_TO_EMAIL_FAIL = "REPLY_TO_EMAIL_FAIL";

export const FREE_EMAIL_NOTIFICATIONS = "FREE_EMAIL_NOTIFICATIONS";
export const FREE_EMAIL_NOTIFICATIONS_SUCCESS = "FREE_EMAIL_NOTIFICATIONS_SUCCESS";
export const FREE_EMAIL_NOTIFICATIONS_FAIL = "FREE_EMAIL_NOTIFICATIONS_FAIL";

export const GET_STORED_EMAILS = "GET_STORED_EMAILS";
export const GET_STORED_EMAILS_SUCCESS = "GET_STORED_EMAILS_SUCCESS";
export const GET_STORED_EMAILS_FAIL = "GET_STORED_EMAILS_FAIL";

export const GET_ADDRESS_BOOK = "GET_ADDRESS_BOOK";
export const GET_ADDRESS_BOOK_SUCCESS = "GET_ADDRESS_BOOK_SUCCESS";
export const GET_ADDRESS_BOOK_FAIL = "GET_ADDRESS_BOOK_FAIL";

export const REMOVE_ADDRESS_BOOK_EMAIL = "REMOVE_ADDRESS_BOOK_EMAIL";
export const REMOVE_ADDRESS_BOOK_EMAIL_SUCCESS = "REMOVE_ADDRESS_BOOK_EMAIL_SUCCESS";
export const REMOVE_ADDRESS_BOOK_EMAIL_FAIL = "REMOVE_ADDRESS_BOOK_EMAIL_FAIL";
